import React from "react"
import { useSelector } from "react-redux"
import { Button } from "reactstrap"
import styles from "./FollowupTab.module.scss"

export default function FollowupTab({
	followup,
	selectedPlayer,
	setFollowupPlayer,
	followupEvent,
	followupPlayer,
	setFollowupEvent,
}) {
	const { homeTeam, awayTeam } = useSelector((state) => state.players)

	const onSelectEvent = (event) => {
		if (followupPlayer) setFollowupPlayer({})
		setFollowupEvent(event)
	}

	const onSelectPlayer = (player) => {
		if (followupEvent) setFollowupEvent()
		if (player === followupPlayer) setFollowupPlayer({})
		else setFollowupPlayer(player)
	}

	const createGrid = () => {
		switch (followup?.type) {
			case "event":
				return followup.events.map(createEventBtn)
			case "teamPlayers":
				const allyTeam =
					homeTeam.name == selectedPlayer.team ? homeTeam : awayTeam

				if (followup.filter) {
					return (
						<div className={styles.grid}>
							{allyTeam.players
								.filter(
									(player) =>
										player.playerId !== selectedPlayer.playerId
								)
								.filter((player) =>
									followup.filter.includes(player.position)
								)
								.map(createPlayerButtons)}
							<hr />
							{allyTeam.players
								.filter(
									(player) =>
										player.playerId !== selectedPlayer.playerId
								)
								.filter(
									(player) =>
										!followup.filter.includes(player.position)
								)
								.map(createPlayerButtons)}
						</div>
					)
				}
				return allyTeam.players
					.filter((player) => player.playerId !== selectedPlayer.playerId)
					.map(createPlayerButtons)
			case "enemyPlayers":
				const enemyTeam =
					homeTeam.name != selectedPlayer.team ? homeTeam : awayTeam

				if (followup.filter) {
					return (
						<div>
							<div className={styles.innerGrid}>
								{enemyTeam.players
									.filter((player) =>
										followup.filter.includes(player.position)
									)
									.map(createPlayerButtons)}
							</div>
							<hr />
							<div className={styles.innerGrid}>
								{enemyTeam.players
									.filter(
										(player) =>
											!followup.filter.includes(
												player.position
											)
									)
									.map(createPlayerButtons)}
							</div>
						</div>
					)
				}
				return enemyTeam.players.map(createPlayerButtons)
			default:
				return (
					<h1>
						Došlo je do neočekivane greške, molimo vas, probajte opet.
					</h1>
				)
		}
	}

	const createPlayerButtons = (player, index) => {
		const isSelectedPlayer = followupPlayer.playerId == player.playerId

		return (
			<div className={styles.playerBtn} key={`eventButton-${index}`}>
				<div
					className={`${styles.playerTNum} ${
						isSelectedPlayer ? styles.active : ""
					}`}
				>
					{player.tshirtNumber}
				</div>
				<Button.Ripple
					color="primary"
					outline={!isSelectedPlayer}
					size="lg"
					onClick={() => onSelectPlayer(player)}
				>
					{`${player.name} ${player.surname}`}
				</Button.Ripple>
			</div>
		)
	}

	const createEventBtn = (event, index) => {
		return (
			<Button.Ripple
				key={`eventButton-${index}`}
				color="primary"
				outline={!(followupEvent == event)}
				size="lg"
				onClick={() => onSelectEvent(event)}
			>
				{event}
			</Button.Ripple>
		)
	}

	return (
		<>
			<h6 className={styles.selectedPlayerText}>
				Izabran igrač: ({selectedPlayer.tshirtNumber}) {selectedPlayer.name}{" "}
				{selectedPlayer.surname}
			</h6>
			{followup?.type && (
				<>
					{followup.allowIgnore && (
						<span className={styles.optional}>{"(Opcionalno) "}</span>
					)}
					<h2 className="text-center">
						{followup.type === "event"
							? "Izaberi popratni event"
							: "Izaberi igrača iz " +
							  (followup.type === "enemyPlayers"
									? "protivničke ekipe"
									: "iste ekipe")}
					</h2>
				</>
			)}
			<div className={followup?.filter ? "" : styles.grid}>{createGrid()}</div>
		</>
	)
}
